import { usageStylesPart1 } from "./usage-styles/usageStyles-part1.ts";
import { usageStylesPart2 } from "./usage-styles/usageStyles-part2.ts";
import { usageStylesPart3 } from "./usage-styles/usageStyles-part3.ts";

export const usageStylesString = [usageStylesPart1, usageStylesPart2, usageStylesPart3].join("\n");
